<template>
  <div id="auto-logout">
    <!-- <auto-logout></auto-logout>-->
    <!-- <div v-if="warningZone"> -->
       <b-modal
          v-model="warningZone"
          has-modal-card
          trap-focus
          :destroy-on-hide="false"
          aria-role="dialog"
          aria-label="Example Modal"
          aria-modal>
          <div class="modal-card">
            <div class="modal-card-body">
              <p class="has-text-centered">Are you still using our system?</p>
              <p class="has-text-centered">Move your mouse to let us know !</p>
            </div>
          </div>
      </b-modal>
    <!-- </div> -->
    <!-- <button @click="handleIcon()">Gerakan Pandai</button> -->
    <!-- <router-view></router-view> -->
  </div>
</template>

<script>
export default {
  //  name: 'App',
   time:1000,
    data : function(){
      return{
        events: ['click','mousemove','mousedown','scroll','load','keypress'],
        warningTimer:null,
        logoutTimer:null,
        warningZone:false,
      }
    },

    methods:{
      setTimer:function(){
        this.warningTimer = setTimeout(this.warningMessage, 18 * 60 * 1000);//2
        this.logoutTimer = setTimeout(this.logoutUser, 30 * 60 * 1000);//3

        this.warningZone = false
      },
      warningMessage:function()
      {
          // this.$buefy.dialog.alert('Logout is expired!')
        
          this.warningZone = true;
      },

      logoutUser: function()
      {
        this.$session.destroy()
        this.$router.push('/')
        this.warningZone = false;
      },

      resetTimer:function()
      {
        clearTimeout(this.warningTimer);
        clearTimeout(this.logoutTimer);
        this.setTimer();
      },

    },
    mounted(){
      
      this.events.forEach(function(event){
        window.addEventListener(event,this.resetTimer);
      },this);

      this.setTimer();
      

    },
     destroyed(){
      this.events.forEach(function(event){
        window.removeEventListener(event,this.resetTimer);
      },this);

      this.resetTimer();
    }
 
}
</script>

<style>
  /* .bg{
    width: 100%;
  } */
</style>


